import { Avatar, Overline, Responsive, UIHeading4, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './BuilderInfo.css';
import { useEventCallback } from '@cian/react-utils';
import { IBuilderInfo } from '../../../../types/buildersProjects';
import { Link } from '../../../Link';

interface IBuilderInfoProps extends IBuilderInfo {
  phoneButton?: React.ReactNode;
}

export const BuilderInfo: React.FC<IBuilderInfoProps> = ({ name, logo, foundationYear, url, phoneButton }) => {
  const handleCompanyClick = useEventCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
  });

  return (
    <div className={styles['container']}>
      <div className={styles['logo']}>
        <Responsive desktop>
          <Avatar size={64} type="builder" src={logo} />
        </Responsive>
        <Responsive tablet phone>
          <Avatar size={40} type="builder" src={logo} />
        </Responsive>
      </div>

      <Responsive desktop>
        <Overline color="gray60_100">Строительная компания</Overline>
      </Responsive>

      <div className={styles['name']}>
        <UIHeading4>
          <Link className={styles['link']} href={url} rel="noopener noreferrer" onClick={handleCompanyClick}>
            {name}
          </Link>
        </UIHeading4>
      </div>

      <div className={styles['foundation']}>
        <UIText3 color="current_color">Работает с {foundationYear} года</UIText3>
      </div>

      <Responsive desktop>{phoneButton}</Responsive>
    </div>
  );
};
